(function() {
  const INLINE_TAGS = new Set([
    'SPAN', 'ABBR', 'LABEL', 'SMALL', 'STRONG', 'EM', 'P',
    'H1', 'H2', 'H3', 'H4', 'H5', 'H6', 'A', 'BUTTON'
  ]);

  const SKIP_TAGS = new Set([
    'IFRAME', 'META', 'LINK', 'SCRIPT', 'STYLE', 'SVG', 'PATH', 'TITLE', 'HTML', 'BODY'
  ]);

  function shouldUseNativeTooltip(el) {
    return !!(
      el &&
      el.closest &&
      (
        el.closest('[data-tooltip-skip="1"]') ||
        el.closest('th, td')
      )
    );
  }

  function restoreNativeTooltip(el) {
    if (!el || !el.classList || !el.classList.contains('has-tooltip')) return;
    if (!(shouldUseNativeTooltip(el) || el.dataset.tooltipSkip === '1')) return;

    const text = (el.dataset && el.dataset.tooltip) || el.getAttribute('aria-label');
    if (text && !el.getAttribute('title')) {
      el.setAttribute('title', text);
    }

    el.classList.remove('has-tooltip');
    el.classList.remove('has-tooltip-inline');
    el.removeAttribute('data-tooltip');
  }

  function shouldDecorate(el) {
    if (!el || !el.tagName) return false;
    if (SKIP_TAGS.has(el.tagName)) return false;
    if (el.dataset.tooltipSkip === '1') return false;
    if (shouldUseNativeTooltip(el)) return false;

    const title = el.getAttribute('title');
    return !!(title && title.trim().length > 0);
  }

  function decorateElement(el) {
    if (!shouldDecorate(el)) return;
    const title = el.getAttribute('title').trim();

    if (!el.dataset.tooltip) {
      el.dataset.tooltip = title;
    }

    el.setAttribute('aria-label', title);
    el.removeAttribute('title');
    el.classList.add('has-tooltip');

    if (INLINE_TAGS.has(el.tagName)) {
      el.classList.add('has-tooltip-inline');
    }
  }

  function decorateRoot(root) {
    if (!root) return;
    if (root.nodeType === Node.ELEMENT_NODE) {
      restoreNativeTooltip(root);
      decorateElement(root);
    }

    const scope = root.querySelectorAll ? root : document;
    scope.querySelectorAll('.has-tooltip').forEach(restoreNativeTooltip);
    scope.querySelectorAll('[title]').forEach(decorateElement);
  }

  function setupObserver() {
    if (!window.MutationObserver || !document.body) return;

    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType !== Node.ELEMENT_NODE) return;
          decorateRoot(node);
        });
      });
    });

    observer.observe(document.body, { childList: true, subtree: true });
  }

  document.addEventListener('DOMContentLoaded', () => {
    decorateRoot(document);
    setupObserver();
  });
})();
